module.exports = __webpack_public_path__ + "static/media/logo800.4f45fb42.png";